import InnerItem from './InnerItem';

export default InnerItem;